/**
 * Мелочи экранов ролика: секунды (число моноширинным, единица — обычным шрифтом) и переключатель
 * «лицо в кадре / без лица» (`shot_face`, v2 §1.2) для карточки кадра и страницы кадра.
 */

import clsx from "clsx";

import { secNum } from "@/lib/videoTimeline";
import type { ShotFace } from "@/lib/video";

/**
 * «15 с»: число табличными цифрами основного шрифта (`tabular-nums`), а не `.tnum`: у `.tnum`
 * моноширинный шрифт, пробел и запятая в нём шириной в цифру — «15  с» читался как двойной пробел (v2 §0).
 */
export function Sec({ ms, className }: { ms: number | null | undefined; className?: string }) {
  if (ms === null || ms === undefined) return <span className={className}>—</span>;
  return (
    <span className={clsx("whitespace-nowrap", className)}>
      <span className="tabular-nums">{secNum(ms)}</span> с
    </span>
  );
}

const FACE_OPTIONS: { value: ShotFace; label: string; title: string }[] = [
  { value: "visible", label: "лицо в кадре", title: "лицо героини видно — модели, отклоняющие лица, отдадут кадр запасной" },
  { value: "hidden", label: "без лица", title: "лица в кадре нет (спина, деталь) — кадр снимет любая модель" },
];

/** Сегментный переключатель «лицо в кадре / без лица». */
export function FaceToggle({
  value,
  disabled = false,
  onChange,
}: {
  value: ShotFace;
  disabled?: boolean;
  onChange: (next: ShotFace) => void;
}) {
  return (
    <div role="radiogroup" aria-label="лицо в кадре" className="inline-flex overflow-hidden rounded-[var(--radius-ui)] border border-border">
      {FACE_OPTIONS.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={on}
            title={o.title}
            disabled={disabled}
            onClick={() => {
              if (!on) onChange(o.value);
            }}
            className={clsx(
              "h-7 px-2 text-[12px] transition-colors disabled:opacity-50",
              on ? "bg-accent-dim font-medium text-accent-text" : "bg-bg text-fg-muted hover:bg-bg-hover hover:text-fg",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
